import OrchestratorAPI from './common';

import {
  CanonicalFieldType,
  CreateValues,
} from '../models/orchestrator/canonicalFieldType';

export default class API extends OrchestratorAPI {
  protected readonly API_PATH = '/canonical-field-types';

  async findAll(): Promise<CanonicalFieldType[]> {
    const url = this.constructPath('/');
    const { canonicalFieldTypes } = await this.common.getJSON(url);
    return canonicalFieldTypes.map(this.deserialize);
  }

  async create(values: CreateValues): Promise<CanonicalFieldType> {
    const url = this.constructPath('/');
    const { canonicalFieldType } = await this.common.postJSON(url, values);
    return this.deserialize(canonicalFieldType);
  }
}
